import { createSelector } from "@reduxjs/toolkit";
import { AppState } from "../..";
import { IfilterObj } from "../types";
import { encode as base64Encode } from "base-64";
import { initialGeoRegion } from "../../../components/helpers";

export const geoRegionSelector = createSelector(
    [(state: AppState) => state.notificationDeviceFilter.geoRegion],
    (geoRegion) => geoRegion || initialGeoRegion
);

export const addDeviceGeoRegionSelector = createSelector(
    [(state: AppState) => state.notificationDeviceFilter.addDeviceGeoRegion],
    (geoRegion) => geoRegion || initialGeoRegion
);

export const groupKeySelector = (state: AppState) => state.notificationDeviceFilter.groupKey;
export const siteGroupSelector = (state: AppState) => state.notificationDeviceFilter.siteGroup;
export const addDeviceSiteGroupSelector = (state: AppState) => state.notificationDeviceFilter.addDeviceSiteGroup;
export const isNotificationDeviceAssociationProgressSelector = (state: AppState) => state.notificationDeviceFilter.isNotificationDeviceAssociationProgress || false;
export const isAssociatedDevicesRemovedSelector = (state: AppState) => state.notificationDeviceFilter.isAssociatedDevicesRemoved || false;


export const urlRemoveParameterSelector = createSelector(
    siteGroupSelector,
    addDeviceSiteGroupSelector,
    geoRegionSelector,
    addDeviceGeoRegionSelector,
    groupKeySelector,
    isNotificationDeviceAssociationProgressSelector,

    (siteGroup, addDeviceSiteGroup, geoRegionName, geoAddDeviceRegionName, groupKey, isNotificationDeviceAssociationProgress) => {
        const params = new URLSearchParams();
        const paramsString: IfilterObj = { type: "AND", operator: "", fieldName: "", value: "", predicates: [] };


        if (geoRegionName && geoRegionName.name) {
            paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "geoRegionName", value: geoRegionName.name, predicates: [{}] });
        }

        if (siteGroup) {
            paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "siteGroupName", value: siteGroup, predicates: [{}] });
        }


        if (groupKey && groupKey.value !== "NONE") {
            paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "groupKey", value:  groupKey.value, predicates: [{}] });
        }

        const base64EncodedStr = base64Encode(JSON.stringify(paramsString));
        if (paramsString?.predicates.length > 0) {
            base64EncodedStr && params.append("filters", base64EncodedStr);
        }

        return params;
    }
);


export const urlAddParameterSelector = createSelector(
    siteGroupSelector,
    addDeviceSiteGroupSelector,
    geoRegionSelector,
    addDeviceGeoRegionSelector,
    groupKeySelector,
    isNotificationDeviceAssociationProgressSelector,

    (siteGroup, addDeviceSiteGroup, geoRegionName, geoAddDeviceRegionName, groupKey, isNotificationDeviceAssociationProgress) => {
        const params = new URLSearchParams();
        const paramsString: IfilterObj = { type: "AND", operator: "", fieldName: "", value: "", predicates: [] };

        if (geoAddDeviceRegionName && geoAddDeviceRegionName.name) {
            paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "geoRegionName", value: geoAddDeviceRegionName.name, predicates: [{}] });
        }

        if (addDeviceSiteGroup) {
            paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "siteGroupName", value: addDeviceSiteGroup, predicates: [{}] });
        }

        if (groupKey && groupKey.value !== "NONE") {
            paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "groupKey", value: "", predicates: [{}] });
        }

        const base64EncodedStr = base64Encode(JSON.stringify(paramsString));
        if (paramsString?.predicates.length > 0) {
            base64EncodedStr && params.append("filters", base64EncodedStr);
        }

        return params;
    }
);